/**
 * Composant de chargement pour le Dashboard
 * @module dashboard/components/LoadingFallback
 */

import React from 'react';
import '../styles/loadingStyles.css';

/**
 * Composant de chargement stylé avec animation
 * @returns {JSX.Element}
 */
const LoadingFallback = () => (
  <div className="loading-container">
    <div className="loading-spinner">
      <div className="spinner-ring"></div>
      <div className="spinner-ring"></div>
      <div className="spinner-ring"></div>
    </div>
    <p className="loading-text">Chargement...</p>
  </div>
);

export default LoadingFallback;
